import { observable, action } from 'mobx';

// 所有升级通用这一个store
export default class UpgradeStore {
  @observable module = ''; // 当前正在升级的模组

  @observable module = ''; // 当前正在升级的模组

  @observable downloadUrl = ''; // 升级文件下载地址

  @observable MD5 = ''; // 升级文件校验MD5

  @observable version = 0;

  @observable firmwaretype = '';

  @observable newVersion = 0;

  @observable progress = 0;

  @observable status = 'default';

  @observable startTime = '';

  @observable spendTime = '';

  @action setNewVersion(version) {
    this.newVersion = version;
  }

  @observable isRebootCPU1 = false; // 地磁版本更新后CPU1重启成功状态
}

export const upgradeStore = new UpgradeStore();
